import { useCallback, useMemo } from 'react'
import { useTranslation } from 'react-i18next'

export const useDateFormat = (
  options?: Intl.DateTimeFormatOptions,
  locale?: string
) => {
  const { i18n } = useTranslation()

  const formatter = useMemo(() => {
    return new Intl.DateTimeFormat(locale || i18n.language, options)
    // We track specific options in the dependency array for optimal re-rendering
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    locale,
    i18n.language,
    options?.dateStyle,
    options?.timeStyle,
    options?.hour12,
    options?.weekday,
    options?.year,
    options?.month,
    options?.day,
    options?.hour,
    options?.minute,
    options?.second,
    options?.timeZone,
  ])

  const format = useCallback(
    (date: Date | string | null | undefined) => {
      if (!date) {
        return '—'
      }
      const parsed = typeof date === 'string' ? new Date(date) : date

      return formatter.format(parsed)
    },
    [formatter]
  )

  return format
}

export default useDateFormat
